(function () {
  'use strict';

  var URL_KEY = 'sns_continue_url';
  var SCROLL_KEY = 'sns_continue_scroll';
  var RESTORE_KEY = 'sns_continue_restore';

  function getUrl(raw) {
    try {
      var url = new URL(raw, window.location.origin);

      if (url.origin !== window.location.origin) return null;

      return url;
    } catch (e) {
      return null;
    }
  }

  /*
   * Páginas que sí consideramos un lugar lógico
   * al cual regresar para "Continue shopping".
   */
  function isShoppingContext(url) {
    if (!url) return false;

    var path = url.pathname;

    /* Home */
    if (path === '/') return true;

    /* Colecciones, excepto /collections/all */
    if (
      path.indexOf('/collections/') === 0 &&
      path !== '/collections/all'
    ) {
      return true;
    }

    /* Search, conservando query */
    if (path === '/search') return true;

    return false;
  }

  function saveCurrentContext() {
    try {
      var url = getUrl(window.location.href);

      if (!isShoppingContext(url)) return;

      sessionStorage.setItem(URL_KEY, url.href);
      sessionStorage.setItem(
        SCROLL_KEY,
        String(Math.max(0, Math.round(window.scrollY || 0)))
      );
    } catch (e) {}
  }

  /*
   * Si llegamos aquí usando Continue shopping,
   * restaura aproximadamente la posición anterior.
   */
  function restoreScrollIfNeeded() {
    try {
      if (sessionStorage.getItem(RESTORE_KEY) !== '1') return;

      var savedUrl = getUrl(sessionStorage.getItem(URL_KEY));
      var currentUrl = getUrl(window.location.href);

      if (!savedUrl || !currentUrl) return;

      if (
        savedUrl.pathname !== currentUrl.pathname ||
        savedUrl.search !== currentUrl.search
      ) {
        return;
      }

      sessionStorage.removeItem(RESTORE_KEY);

      var y = parseInt(sessionStorage.getItem(SCROLL_KEY) || '0', 10);

      if (!Number.isFinite(y) || y <= 0) return;

      function restore() {
        window.scrollTo(0, y);
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(restore);
      });

      /* Segundo ajuste después de que imágenes/layout terminen de acomodarse */
      setTimeout(restore, 250);
    } catch (e) {}
  }

  /*
   * API pequeña que utilizará nuestro carrito.
   */
  window.SNSContinueShopping = {
    getDestination: function (fallback) {
      try {
        var saved = getUrl(sessionStorage.getItem(URL_KEY));

        if (saved && isShoppingContext(saved)) {
          return saved.href;
        }
      } catch (e) {}

      return fallback || '/';
    },

    prepareNavigation: function () {
      try {
        sessionStorage.setItem(RESTORE_KEY, '1');
      } catch (e) {}
    }
  };

  /*
   * Guardamos al cargar una colección / search / home.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      restoreScrollIfNeeded();
      saveCurrentContext();
    });
  } else {
    restoreScrollIfNeeded();
    saveCurrentContext();
  }

  /*
   * Importantísimo:
   * justo antes de abandonar la colección guardamos
   * la posición real donde estaba el usuario.
   */
  window.addEventListener('pagehide', saveCurrentContext);
})();